import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { CartCouponModule, CartSharedModule } from '@spartacus/cart/base/components'
import { CmsConfig, FeaturesConfigModule, I18nModule, UrlModule, provideConfig } from '@spartacus/core'
import { ItemCounterModule, MediaModule, OutletModule, PromotionsModule, SpinnerModule } from '@spartacus/storefront'
import { SharedModule } from '../../shared/shared.module'
import { CustomCartItemListStockComponent } from './custom-cart-item-list-stock/custom-cart-item-list-stock.component'
import { CustomCartItemListComponent } from './custom-cart-item-list/custom-cart-item-list.component'
import { CustomCartItemStockComponent } from './custom-cart-item-stock/custom-cart-item-stock.component'
import { CustomCartItemComponent } from './custom-cart-item/custom-cart-item.component'
import { CustomCartTotalsComponent } from './custom-cart-totals/custom-cart-totals.component'
import { CustomOrderSummaryComponent } from './custom-order-summary/custom-order-summary.component'

@NgModule({
  declarations: [
    CustomCartItemListComponent,
    CustomCartItemComponent,
    CustomOrderSummaryComponent,
    CustomCartTotalsComponent,
    CustomCartItemListStockComponent,
    CustomCartItemStockComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CartCouponModule,
    ReactiveFormsModule,
    UrlModule,
    NgbModule,
    PromotionsModule,
    I18nModule,
    MediaModule,
    ItemCounterModule,
    FeaturesConfigModule,
    SharedModule,
    SpinnerModule,
    CartSharedModule,
    OutletModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartTotalsComponent: {
          component: CustomCartTotalsComponent
        }
      }
    })
  ],
  exports: [
    CustomCartItemListComponent,
    CustomCartItemComponent,
    CustomOrderSummaryComponent,
    CustomCartTotalsComponent,
    CustomCartItemListStockComponent
  ]
})
export class CustomCartSharedModule {}
